import { Checkbox } from "src/interface/checkbox";

export class FormCampos {
  title: string = "Selecione os campos";
  info: string = "Escolha quais campos devem ser incluídos no formulário de agendamento.";
  nome: string = 'Marcar Todos';
  check: boolean = false;
  cor: string = 'radial-primary';
  campos: Checkbox[];

  constructor() {
    this.campos = [
      {
        nome: 'Placa do Veículo',
        check: false,
        cor: 'radial-primary',
        visivel: true
      },{
        nome: 'Nome do Motorista',
        check: false,
        cor: 'radial-primary',
        visivel: true
      },{
        nome: 'CPF',
        check: false,
        cor: 'radial-primary',
        visivel: true
      },{
        nome: 'Telefone',
        check: true,
        cor: 'radial-primary',
        visivel: false
      },{
        nome: 'E-mail',
        check: true,
        cor: 'radial-primary',
        visivel: false
      },{
        nome: 'Número da Nota Fiscal',
        check: true,
        cor: 'radial-primary',
        visivel: false
      },{
        nome: 'Número do Pedido',
        check: false,
        cor: 'radial-primary',
        visivel: true
      },{
        nome: 'Fornecedor',
        check: false,
        cor: 'radial-primary',
        visivel: true
      },{
        nome: 'Peso',
        check: false,
        cor: 'radial-primary',
        visivel: true
      },{
        nome: 'Veículo',
        check: false,
        cor: 'radial-primary',
        visivel: true
      }
    ];

    this.campos = this.campos.map(campo => Object.assign({}, campo));

  }

}


